import React, { useEffect, useState } from 'react'
import SubHeader from '../Shared/Display/SubHeader'
import DateTimeFilter from '../Shared/Buttons/DateTimeFilter'
import FilterBy from '../Shared/Filters/FilterBy'
import CustomFilter from '../Shared/Buttons/CustomFilter'
import { useDispatch, useSelector } from 'react-redux'
import { fetchPushNotifications } from '../Redux/Actions/Notifications'
import { fetchGlobalConfig } from '../Redux/Actions/Global'
import { dateTime } from '../Shared/timeutils'
import { componentCreated, updateDateFilter, updateGroupFilter } from '../Redux/Actions/DateFilter'
import NotificationsTable from '../Shared/Data/NotificationsTable'
import { useLocation, useNavigate } from 'react-router'
import {
  getDateFilter,
  getGroupFilter,
  processDate,
  processGroup,
  formatStartEndDates,
  composeFilterString
} from '../utils/analytics-utils'
import { addQuery } from '../utils/router-utils'

/** @const {number} pageTotals */
const pageTotals = 5

function Notifications () {
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [contentPage, setContentPage] = useState(1)
  const [contentSort, setContentSort] = useState('createdDate DESC')
  // const [eventPage, setEventPage] = useState(1)
  // const [eventSort, setEventSort] = useState('createdDate DESC')
  const [alertPage, setAlertPage] = useState(1)
  const [alertSort, setAlertSort] = useState('createdDate DESC')
  const [smsPage, setSmsPage] = useState(1)
  const [smsSort, setSmsSort] = useState('createdDate DESC')
  const [tableToUpdate, setTableToUpdate] = useState('ALL')

  const enableFeatureSmsAlerts = useSelector(state => state.globalConfig.enableFeatureSmsAlerts)
  const id = useSelector(state => state.account.ID)
  const notification = useSelector(state => state.notification)
  const userAnalyticsEnabled = useSelector(state => state.account.userAnalyticsEnabled)
  const redirect = useSelector(state => state.account.redirect)
  const status = useSelector(state => state.generateReport.status)
  const dateFilterStore = useSelector(state => state.dateFilter)
  const name = 'Notification'

  let dateFilterFromStore = getDateFilter(dateFilterStore, name)
  dateFilterFromStore = dateFilterFromStore ? dateFilterFromStore.dateFilter || 'Week' : 'Week'
  const [dateFilter, setDateFilter] = useState(dateFilterFromStore)

  const groupFilterFromStore = getGroupFilter(dateFilterStore, name) || ''
  const [groupFilter, setGroupFilter] = useState(groupFilterFromStore)
  const dateInterval = dateFilter ? dateFilter.dateInterval || null : null

  useEffect(() => {
    dispatch(componentCreated(name))
  }, [])

  useEffect(() => {
    update(processDate(dateFilter), processGroup(groupFilter))
  }, [contentPage, contentSort, alertPage, alertSort, smsPage, smsSort, tableToUpdate])

  useEffect(() => {
    newQuery(location.search.substring(1).split('&'))
  }, [])

  useEffect(() => {
    dispatch(fetchGlobalConfig())
  }, [])

  const newQuery = (query) => {
    const qobj = {}
    let newDateFilter
    query.forEach((q) => {
      qobj[q.split('=')[0]] = q.split('=')[1]
    })
    if (dateFilter === 'Custom' && dateInterval) {
      newDateFilter = dateInterval
    } else {
      newDateFilter = dateFilter
    }
    update(processDate(newDateFilter), processGroup(groupFilter), id)
  }

  const update = (date, group, newID) => {
    const formattedDate = formatStartEndDates(date)
    const ID = newID || id
    if (tableToUpdate === 'ALL' || tableToUpdate === 'CONTENT') {
      dispatch(fetchPushNotifications(ID, formattedDate.start, formattedDate.end,
        {
          limit: pageTotals,
          offset: (contentPage - 1) * pageTotals,
          group: group.groups,
          profile: group.profiles,
          sort: contentSort,
          deviceType: group.alt,
          pushNotificationType: 'CONTENT'
        }))
    }
    if (tableToUpdate === 'ALL' || tableToUpdate === 'ALERT') {
      dispatch(fetchPushNotifications(ID, formattedDate.start, formattedDate.end,
        {
          limit: pageTotals,
          offset: (alertPage - 1) * pageTotals,
          group: group.groups,
          profile: group.profiles,
          sort: alertSort,
          deviceType: group.alt,
          pushNotificationType: 'ALERT'
        }))
    }
    if (tableToUpdate === 'ALL' || tableToUpdate === 'SMS') {
      dispatch(fetchPushNotifications(ID, formattedDate.start, formattedDate.end,
        {
          limit: pageTotals,
          offset: (smsPage - 1) * pageTotals,
          group: group.groups,
          profile: group.profiles,
          sort: smsSort,
          deviceType: group.alt,
          pushNotificationType: 'SMS'
        }))
    }
    setTableToUpdate('ALL')
  }

  const changeDateFilter = (newFilter, isCustom) => {
    if (isCustom) {
      dispatch(updateDateFilter(name, 'Custom', newFilter))
    } else {
      dispatch(updateDateFilter(name, newFilter))
    }
    const f = `${composeFilterString(groupFilter.profiles, groupFilter.groups)}_${groupFilter.alt || ''}`
    addQuery({ date: newFilter, filter: f }, location, navigate)
    setDateFilter(newFilter)
    if (newFilter !== 'Custom') {
      update(processDate(newFilter), processGroup(groupFilter))
    }
  }

  const changeGroupFilter = (newFilter) => {
    let newDateFilter
    if (dateFilter === 'Custom' && dateInterval) {
      newDateFilter = dateInterval
    } else {
      newDateFilter = dateFilter
    }

    dispatch(updateGroupFilter(name, newFilter))
    const f = `${composeFilterString(newFilter.profiles, newFilter.groups)}_${newFilter.alt || ''}`
    addQuery({ date: newDateFilter, filter: f }, location, navigate)
    setGroupFilter(newFilter)
    update(processDate(newDateFilter), processGroup(newFilter))
  }

  if (userAnalyticsEnabled) {
    return (
      <div id='NotificationsPage'>
        <div className='toolbar'>
          <SubHeader type='Notifications' />
          <DateTimeFilter filterBy={changeDateFilter} currentFilter={dateFilter} />
          <div className='reportButtons'>
            {/* <FavoriteButton /> */}
          </div>
        </div>
        {(dateFilter !== 'Day' && dateFilter !== 'Week' && dateFilter !== 'Month') ? <CustomFilter filterBy={changeDateFilter} currentFilter={dateFilter} /> : ''}
        <FilterBy changeFilter={changeGroupFilter} currentFilter={processGroup(groupFilter)} showProfiles showGroups type='Device' />
        <NotificationsTable
          title='Content Push Notifications'
          status={status}
          // generateReportClick={() => {
          //   const dates = processDate(dateFilter)
          //   const group = processGroup(groupFilter)
          //   const options = { group: group.groups, profile: group.profiles, sort: contentSort, deviceType: group.alt }
          //   generateUserReport(id, dates.start.toISOString(), dates.end.toISOString(), options)
          // }}
          groupFilter={processGroup(groupFilter)}
          data={notification.pushContentNotifications || []}
          fields={[{ ref: 'title', title: 'Title' },
            { ref: 'totalSent', title: 'Total Sent' },
            { ref: 'totalDelivered', title: 'Total Delivered' },
            { ref: 'totalFailed', title: 'Total Failed' },
            { ref: 'totalErrored', title: 'Total Errored' },
            { ref: 'createdDate', title: 'Content Created Date', toMap: (day) => dateTime(day) }]}
          changeOffset={(i) => {
            setContentPage(i)
            setTableToUpdate('CONTENT')
          }}
          toggleSort={(key) => {
            if (contentSort.split(' ')[0] === key && contentSort.split(' ')[1] === 'DESC') {
              setContentSort(key + ' ASC')
              setTableToUpdate('CONTENT')
            } else {
              setContentSort(key + ' DESC')
              setTableToUpdate('CONTENT')
            }
          }}
          sort={contentSort}
          page={contentPage}
          totalNotifications={Math.ceil(notification.pushContentNotificationsLength / pageTotals)}
          showTooltip
          tooltipText='You may not see your Content Push Notification immediately due to data refresh occurring every 5 minutes.'
        />

        <br />

        <NotificationsTable
          title='Broadcast Alerts'
          status={status}
          // generateReportClick={() => {
          //   const dates = processDate(dateFilter)
          //   const group = processGroup(groupFilter)
          //   const options = { group: group.groups, profile: group.profiles, sort: eventSort, deviceType: group.alt }
          //   generateUserReport(id, dates.start.toISOString(), dates.end.toISOString(), options)
          // }}
          groupFilter={processGroup(groupFilter)}
          data={notification.pushAlertNotifications || []}
          fields={[{ ref: 'title', title: 'Title' },
            { ref: 'totalSent', title: 'Total Sent' },
            { ref: 'totalDelivered', title: 'Total Delivered' },
            { ref: 'totalFailed', title: 'Total Failed' },
            { ref: 'totalErrored', title: 'Total Errored' },
            // { ref: 'remaining', title: 'Remaining' },
            { ref: 'createdDate', title: 'Alert Created Date', toMap: (day) => dateTime(day) }]}
          changeOffset={(i) => {
            setAlertPage(i)
            setTableToUpdate('ALERT')
          }}
          toggleSort={(key) => {
            if (alertSort.split(' ')[0] === key && alertSort.split(' ')[1] === 'DESC') {
              setAlertSort(key + ' ASC')
              setTableToUpdate('ALERT')
            } else {
              setAlertSort(key + ' DESC')
              setTableToUpdate('ALERT')
            }
          }}
          sort={alertSort}
          page={alertPage}
          totalNotifications={Math.ceil(notification.pushAlertNotificationsLength / pageTotals)}
          showTooltip
          tooltipText='You may not see your Broadcast Alert immediately due to data refresh occurring every 5 minutes.'
        />

        { enableFeatureSmsAlerts && (
          <NotificationsTable
            title='SMS Alerts'
            status={status}
            // generateReportClick={() => {
            //   const dates = processDate(dateFilter)
            //   const group = processGroup(groupFilter)
            //   const options = { group: group.groups, profile: group.profiles, sort: eventSort, deviceType: group.alt }
            //   generateUserReport(id, dates.start.toISOString(), dates.end.toISOString(), options)
            // }}
            groupFilter={processGroup(groupFilter)}
            data={notification.pushSmsNotifications || []}
            fields={[{ ref: 'title', title: 'Title' },
              { ref: 'totalSent', title: 'Total Sent' },
              { ref: 'totalDelivered', title: 'Total Delivered' },
              { ref: 'totalUndelivered', title: 'Total Undelivered' },
              { ref: 'totalFailed', title: 'Total Failed' },
              // { ref: 'remaining', title: 'Remaining' },
              { ref: 'createdDate', title: 'SMS Created Date', toMap: (day) => dateTime(day) }]}
            changeOffset={(i) => {
              setSmsPage(i)
              setTableToUpdate('SMS')
            }}
            toggleSort={(key) => {
              if (smsSort.split(' ')[0] === key && smsSort.split(' ')[1] === 'DESC') {
                setSmsSort(key + ' ASC')
                setTableToUpdate('SMS')
              } else {
                setSmsSort(key + ' DESC')
                setTableToUpdate('SMS')
              }
            }}
            sort={smsSort}
            page={smsPage}
            totalNotifications={Math.ceil(notification.pushSmsNotificationsLength / pageTotals)}
            showTooltip
            tooltipText='You may not see your SMS Alert immediately due to data refresh intervals.'
            route='/sms'
          />
        ) }

        {/* TODO Uncomment these when you want to add event notifications */}

        {/* <br /> */}

        {/* <NotificationsTable */}
        {/*  title='Event Push Notifications' */}
        {/*  status={status} */}
        {/*  // generateReportClick={() => { */}
        {/*  //   const dates = processDate(dateFilter) */}
        {/*  //   const group = processGroup(groupFilter) */}
        {/*  //   const options = { group: group.groups, profile: group.profiles, sort: eventSort, deviceType: group.alt } */}
        {/*  //   generateUserReport(id, dates.start.toISOString(), dates.end.toISOString(), options) */}
        {/*  // }} */}
        {/*  groupFilter={processGroup(groupFilter)} */}
        {/*  data={notification.pushEventNotifications || []} */}
        {/*  fields={[{ ref: 'title', title: 'Title' }, */}
        {/*    { ref: 'totalSent', title: 'Total Sent' }, */}
        {/*    { ref: 'totalDelivered', title: 'Total Delivered' }, */}
        {/*    { ref: 'totalFailed', title: 'Total Failed' }, */}
        {/*    { ref: 'remaining', title: 'Remaining' }, */}
        {/*    { ref: 'createdDate', title: 'Event Created Date', toMap: (day) => numberedDate(day) } ]} */}
        {/*  changeOffset={(i) => { */}
        {/*    setState({ eventPage: i, tableToUpdate: 'EVENT' }, () => { */}
        {/*      update(processDate(dateFilter), processGroup(groupFilter)) */}
        {/*    }) */}
        {/*  } */}
        {/*  } */}
        {/*  toggleSort={(key) => { */}
        {/*    if (eventSort.split(' ')[0] === key && eventSort.split(' ')[1] === 'DESC') { */}
        {/*      setState({ eventSort: key + ' ASC', tableToUpdate: 'EVENT' }, () => { */}
        {/*        update(processDate(dateFilter), processGroup(groupFilter)) */}
        {/*      }) */}
        {/*    } else { */}
        {/*      setState({ eventSort: key + ' DESC', tableToUpdate: 'EVENT' }, () => { */}
        {/*        update(processDate(dateFilter), processGroup(groupFilter)) */}
        {/*      }) */}
        {/*    } */}
        {/*  }} */}
        {/*  sort={eventSort} */}
        {/*  page={eventPage} */}
        {/*  totalNotifications={Math.ceil(notification.pushEventNotificationsLength / pageTotals)} */}
        {/* /> */}
      </div>
    )
  } else {
    return (
      <div className='NotificationTable'>
        <div className='adminPage'>
          <p>Push notifications analytics have not been turned on. To do so, go to Master Administrator Account Settings and enable User Analytics</p>
        </div>
        <div className='adminPageContainer'><a className='buttonRedirect' href={redirect}>Go to Master Administrator Account Settings</a></div>
      </div>
    )
  }
}

export default Notifications
